/* oxlint-disable react/forbid-elements */
import * as React from 'react';

export const TransportIcon: React.FunctionComponent<object> = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="10"
    height="12"
    viewBox="0 0 10 12"
    style={{
      verticalAlign: -2,
    }}
  >
    {/*tslint:disable-next-line:max-line-length*/}
    <path
      fill="#121212"
      fillOpacity=".54"
      fillRule="evenodd"
      d="M.333 8.333c0 .514.228.974.584 1.295v1.039c0 .32.262.583.583.583h.583c.321 0 .584-.262.584-.583v-.584h4.666v.584c0 .32.263.583.584.583H8.5c.32 0 .583-.262.583-.583V9.628c.356-.32.584-.781.584-1.295V2.5C9.667.458 7.578.167 5 .167S.333.458.333 2.5v5.833zm2.042.584a.874.874 0 1 1 0-1.75.874.874 0 1 1 0 1.75zm5.25 0a.874.874 0 1 1 0-1.75.874.874 0 1 1 0 1.75zm.875-3.5h-7V2.5h7v2.917z"
    />
  </svg>
);
